<script>
export default {
    name: "IconFactory"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" viewBox="0 0 24 24">
        <path fill="currentColor"
              d="M22 1h-4a1 1 0 0 0-1 1v7h-2V7a1 1 0 0 0-1.447-.895L9 8.382V7a1 1 0 0 0-1.447-.895l-6 3A1 1 0 0 0 1 10v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Zm-1 2v2h-2V3ZM3 21V10.618l4-2V10a1 1 0 0 0 1.447.895L13 8.618V10a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7h2v14Zm2-8h3v2H5Zm5 0h4v2h-4Zm6 0h3v2h-3ZM5 17h3v2H5Zm5 0h4v2h-4Zm6 0h3v2h-3Z"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
